import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ReactDOM from 'react-dom';
import { RECOMMENDATION_TYPES, ADINSIGHT_LOG_ACTION_TYPE } from '@bingads-webui-campaign/recommendation-core';
import { withUiBlock } from '@bingads-webui/uiblocker';

import template from './template.pug';

export class RecommendationInlineViewFactory extends Backbone.View {
  initialize({
    i18n,
    newI18n,
    deps,
    gridService,
    recommendation,
    logOpportunityEvent,
    router,
    gridView,
    readOnly,
    isMCC,
    perfMarker,
    serverContext,
    getGoalCreationRecommendationWizard,
    s$i18n,
    viewUET,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.newI18n = newI18n;
    this.gridService = gridService;
    this.recommendation = recommendation;
    this.logOpportunityEvent = logOpportunityEvent;
    this.router = router;
    this.gridView = gridView;
    this.childView = null;
    this.opportunityType = this.recommendation.OpportunityType;
    this.readOnly = readOnly;
    this.isMCC = isMCC;
    this.perfMarker = perfMarker;
    this.serverContext = serverContext;
    this.getGoalCreationRecommendationWizard = getGoalCreationRecommendationWizard;
    this.s$i18n = s$i18n;
    this.viewUET = viewUET;
  }

  render() {
    if (this.isMCC) {
      this.deps.appState.set({ account_id: this.recommendation.Target.AccountId });
    }
    switch (this.opportunityType) {
      // [TODO] support more opportunity type
      case RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY:
        import(/* webpackMode: 'eager' */'@bingads-webui-campaign/recommendation-inline-budget-view').then(({ RecommendationInlineBudgetView }) => {
          this.childView = new RecommendationInlineBudgetView({
            deps: this.deps,
            data: this.recommendation,
            i18n: this.i18n,
            router: this.router,
            gridView: this.gridView,
            readOnly: this.readOnly,
            isMCC: this.isMCC,
            gridService: this.gridService,
          });
          this.renderInlineContent();
        });
        break;
      case RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY:
        import(/* webpackMode: 'eager' */'@bingads-webui-campaign/recommendation-inline-budget-view').then(({ RecommendationInlineBudgetView }) => {
          this.childView = new RecommendationInlineBudgetView({
            deps: this.deps,
            data: this.recommendation,
            i18n: this.i18n,
            router: this.router,
            gridView: this.gridView,
            readOnly: this.readOnly,
            isSharedBudget: true,
            isMCC: this.isMCC,
            gridService: this.gridService,
          });
          this.renderInlineContent();
        });
        break;
      case RECOMMENDATION_TYPES.REPAIR_KEYWORD:
        import(/* webpackMode: 'eager' */'@bingads-webui-campaign/recommendation-inline-repair-keywords-view').then(({ RepairKeywordsInlineView }) => {
          this.childView = new RepairKeywordsInlineView({
            deps: this.deps,
            data: this.recommendation,
            i18n: this.i18n,
            router: this.router,
            gridView: this.gridView,
            readOnly: this.readOnly,
            isMCC: this.isMCC,
            gridService: this.gridService,
          });
          this.renderInlineContent();
        });
        break;
      case RECOMMENDATION_TYPES.SITE_LINK:
      case RECOMMENDATION_TYPES.CALLOUT:
        import(/* webpackMode: 'eager' */'@bingads-webui-campaign/recommendation-inline-ad-extension-view').then(({ AdExtensionInlineView }) => {
          this.childView = new AdExtensionInlineView({
            deps: this.deps,
            data: this.recommendation,
            i18n: this.i18n,
            type: this.opportunityType,
            router: this.router,
            gridView: this.gridView,
            readOnly: this.readOnly,
            isMCC: this.isMCC,
            gridService: this.gridService,
          });
          this.renderInlineContent();
        });
        break;
      case RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS:
      case RECOMMENDATION_TYPES.MULTIMEDIA_ADS:
      case RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS:
        import(/* webpackMode: 'eager' */'@bingads-webui-campaign/recommendation-inline-new-ads-view').then(({ NewAdsInlineView }) => {
          this.childView = new NewAdsInlineView({
            deps: this.deps,
            data: this.recommendation,
            i18n: this.i18n,
            newI18n: this.newI18n,
            router: this.router,
            type: this.opportunityType,
            gridView: this.gridView,
            readOnly: this.readOnly,
            isMCC: this.isMCC,
            gridService: this.gridService,
          });
          this.renderInlineContent();
        });
        break;
      case RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS:
        import(/* webpackMode: 'eager' */'@bingads-webui-campaign/recommendation-inline-dynamic-search-ads-view').then(({ DynamicSearchAdsInlineView }) => {
          this.childView = new DynamicSearchAdsInlineView({
            deps: this.deps,
            data: this.recommendation,
            i18n: this.i18n,
            readOnly: this.readOnly,
            isMCC: this.isMCC,
            router: this.router,
            gridView: this.gridView,
            gridService: this.gridService,
          });
          this.renderInlineContent();
        });
        break;
      case RECOMMENDATION_TYPES.REALLOCATE_BUDGET:
        import(/* webpackMode: 'eager' */'@bingads-webui-campaign/recommendation-inline-reallocate-budget-view').then(({ RecommendationReallocateBudgetView }) => {
          this.childView = new RecommendationReallocateBudgetView({
            deps: this.deps,
            data: this.recommendation,
            i18n: this.i18n,
            router: this.router,
            type: this.opportunityType,
            gridView: this.gridView,
            readOnly: this.readOnly,
            isMCC: this.isMCC,
            gridService: this.gridService,
          });
          this.renderInlineContent();
        });
        break;
      case RECOMMENDATION_TYPES.FIX_AD_DESTINATION:
        import(/* webpackMode: 'eager' */'@bingads-webui-campaign/recommendation-inline-fix-ad-destination-view').then(({ RecommendationFixAdDestinationView }) => {
          import(/* webpackMode: 'eager' */'@bingads-webui-component-legacy/upgraded-url/view/urlTestTool').then((UrlTestTool) => {
            this.childView = new RecommendationFixAdDestinationView({
              deps: this.deps,
              data: this.recommendation,
              i18n: this.i18n,
              router: this.router,
              type: this.opportunityType,
              gridView: this.gridView,
              readOnly: this.readOnly,
              isMCC: this.isMCC,
              UrlTestTool: UrlTestTool.default,
            });
            this.renderInlineContent();
          });
        });
        break;
      case RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY:
        import(/* webpackMode: 'eager' */'@bingads-webui-campaign/recommendation-inline-setup-conversion-tracking-view').then(({ RecommendationSetupConversionTrackingView }) => {
          this.childView = new RecommendationSetupConversionTrackingView({
            deps: this.deps,
            data: this.recommendation,
            i18n: this.i18n,
            router: this.router,
            type: this.opportunityType,
            gridView: this.gridView,
            readOnly: this.readOnly,
            isMCC: this.isMCC,
            gridService: this.gridService,
            isRecommendationThirdPartyTaggingEnabled:
              this.deps.permissions.IsRecommendationThirdPartyTaggingEnabled,
          });
          this.renderInlineContent();
        });
        break;
      case RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS:
        import(/* webpackMode: 'eager' */'@bingads-webui-campaign/recommendation-inline-fix-conversion-goal-setting-view').then(({ FixConversionGoalSettingView }) => {
          this.childView = new FixConversionGoalSettingView({
            deps: this.deps,
            data: this.recommendation,
            i18n: this.i18n,
            router: this.router,
            type: this.opportunityType,
            gridView: this.gridView,
            readOnly: this.readOnly,
            isMCC: this.isMCC,
            scope: this.gridService.recommendationService.scope,
            gridService: this.gridService,
            s$i18n: this.s$i18n,
            newI18n: this.newI18n,
            viewUET: this.viewUET,
          });
          this.renderInlineContent();
        });
        break;
      case RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL:
        import(/* webpackMode: 'eager' */'@bingads-webui-campaign/recommendation-inline-create-conversion-goal-view').then(({ CreateConversionGoalView }) => {
          this.childView = new CreateConversionGoalView({
            deps: this.deps,
            data: this.recommendation,
            i18n: this.i18n,
            newI18n: this.newI18n,
            router: this.router,
            type: this.opportunityType,
            gridView: this.gridView,
            readOnly: this.readOnly,
            isMCC: this.isMCC,
            scope: this.gridService.recommendationService.scope,
            gridService: this.gridService,
            permissions: this.deps.permissions,
            perfMarker: this.perfMarker,
            serverContext: this.serverContext,
            getGoalCreationRecommendationWizard: this.getGoalCreationRecommendationWizard,
          });
          this.renderInlineContent();
        });
        break;
      default:
        break;
    }

    // [TODO] may be add something parent template.
    this.$el.html(template());

    _.each(this.recommendation.Opportunities, (opportunity) => {
      const rejectedAd = _.first(opportunity.RejectedAds) || _.first(opportunity.RejectedKeywords)
       || {};
      this.logOpportunityEvent({
        opportunityId: opportunity.OpportunityId,
        campaignId: opportunity.Target.CampaignId,
        type: this.opportunityType,
        action: ADINSIGHT_LOG_ACTION_TYPE.VIEWEDIT,
        accountId: opportunity.Target.AccountId,
        context: {
          FlagId: _.chain(opportunity)
            .result('FlagId')
            .value(),
          OldFinalUrl: rejectedAd.FinalUrl,
          OldTrackingTemplate: rejectedAd.TrackingTemplate,
        },
      });
    });

    return this;
  }

  hasChanged() {
    // backbone view
    if (this.childView instanceof Backbone.View && this.childView.hasChanged) {
      return this.childView.hasChanged();
    }

    // [TODO] react view
    return false;
  }

  apply({ opportunities, userInputs, context = {} }) {
    const { IsRecommendationInlineErrorEnabled } = this.deps.permissions;

    if (IsRecommendationInlineErrorEnabled) {
      return this.gridService.apply({
        opportunities,
        userInputs,
        context,
        hasInlineError: this.childView.hasInlineError || _.noop,
      })
        .then(() => {
          this.trigger('didApply');
          // scroll to top to see feedbacks
          $('html, body').scrollTop(0);
        })
        .catch((errors) => {
          if (_.isFunction(this.childView.dealWithInlineError)) {
            this.childView.dealWithInlineError(errors);
          }
        })
        .finally(withUiBlock(this.$el));
    }
    const closeBlocker = withUiBlock(this.$el);

    return this.gridService.apply({ opportunities, userInputs, context }).finally(() => {
      closeBlocker();
      this.trigger('didApply');
    });
  }

  dismiss({ opportunities }) {
    const closeBlocker = withUiBlock(this.$el);

    return this.gridService.dismiss({ opportunities }).finally(() => {
      closeBlocker();
      this.trigger('didDismiss');
    });
  }

  remove() {
    if (this.childView instanceof Backbone.View) {
      this.childView.remove();
    } else {
      ReactDOM.unmountComponentAtNode(this.el);
    }
  }

  cancel() {
    this.remove();
    this.trigger('cancel');
  }

  renderInlineContent() {
    if (_.isNull(this.childView)) {
      return;
    }
    if (this.childView instanceof Backbone.View) {
      this.childView.render();
      this.childView.on('apply', _.bind(this.apply, this));
      this.childView.on('dismiss', _.bind(this.dismiss, this));
      this.childView.on('cancel', _.bind(this.cancel, this));
      this.$el.append(this.childView.$el);
    } else {
      ReactDOM.render(this.childView, this.el);
    }
  }
}
